import CatchCuttingOrder from 'src/views/Pages/Dashboard/CuttingOrder/Create/CatchCuttingOrder.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const CuttingOrderRoutes = {
  path: 'order',
  name: 'cuttingorder.cutting_order',
  component: MasterTab,
  props: { reference: 'cuttingorderTabs' },
  children: [
    {
      path: 'catchs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'cuttingorder.cutting_order_catchs',
          component: CatchCuttingOrder,
          meta: {
            prefix_permission: 'order_catchs',
          },
        },
      ],
    }
  ]
};

export default CuttingOrderRoutes;